import { c as _c } from "react/compiler-runtime";
import { useCompanyId } from "@context-providers/company-id-provider";
import { MARKUPS_VIEW_QUERY_PARAMS } from "@pages/project-details/project-markups/calendar/use-markups-view-query-params";
import { ProjectMarkupsTableHeaders } from "@pages/project-details/project-markups/project-markups-table-utils";
import { ProjectTabs } from "@router/route-params";
import { generateProjectDetailsRoute, getPreservedQueryParams, useAppParams } from "@router/router-helper";
import { useAppSelector } from "@store/store-helper";
import { currentUserSelector } from "@store/user/user-selector";
import { AnnotationsSummaryEvents } from "@utils/track-event/track-event-list";
import { useTrackEvent } from "@utils/track-event/use-track-event";
import { useLocation } from "react-router-dom";

/** Part of the summary where a link is shown: the overview chart, legend or counts, or the annotations tab KPI bar */

/** Link to the annotations tab with the table filters of a summary part */

/** Returns the link to the annotations tab with the summary filter applied to the table */

/**
 * Returns a function that builds the link to the annotations tab with the table filters
 * of a summary part, plus the current user as assignee when only their markups are shown.
 * The extra props are added to the tracked click event.
 */
export function useMarkupsSummaryLink(scope, extraEventProps) {
  const $ = _c(11);
  const companyId = useCompanyId();
  const {
    projectId
  } = useAppParams();
  const currentUser = useAppSelector(currentUserSelector);
  const location = useLocation();
  const {
    trackEvent
  } = useTrackEvent();
  let t0;
  if ($[0] !== companyId || $[1] !== currentUser || $[2] !== location.search || $[3] !== projectId || $[4] !== scope) {
    t0 = function getHref(t1) {
      const {
        statuses,
        dueDate
      } = t1;
      const path = generateProjectDetailsRoute(companyId, projectId ?? "", ProjectTabs.annotations);
      const search = new URLSearchParams(getPreservedQueryParams(location.search));
      const currentSearch = new URLSearchParams(location.search);
      MARKUPS_VIEW_QUERY_PARAMS.forEach(param => {
        const value = currentSearch.get(param);
        if (value !== null) {
          search.set(param, value);
        }
      });
      statuses.forEach(status => search.append(ProjectMarkupsTableHeaders.status, status));
      if (dueDate) {
        search.append(ProjectMarkupsTableHeaders.dueDate, dueDate);
      }
      if (scope === "mine" && currentUser) {
        search.append(ProjectMarkupsTableHeaders.assignee, currentUser.identity);
      }
      if (scope === "created" && currentUser) {
        search.append(ProjectMarkupsTableHeaders.creator, currentUser.identity);
      }
      return `${path}?${search.toString()}`;
    };
    $[0] = companyId;
    $[1] = currentUser;
    $[2] = location.search;
    $[3] = projectId;
    $[4] = scope;
    $[5] = t0;
  } else {
    t0 = $[5];
  }
  const getHref = t0;
  let t1;
  if ($[6] !== extraEventProps || $[7] !== getHref || $[8] !== scope || $[9] !== trackEvent) {
    t1 = (filter, place) => ({
      href: getHref(filter),
      onClick: () => {
        const props = {
          ...extraEventProps,
          scope,
          place,
          statuses: filter.statuses
        };
        if (filter.dueDate) {
          props.dueDate = filter.dueDate;
        }
        trackEvent({
          name: AnnotationsSummaryEvents.openAnnotations,
          props
        });
      }
    });
    $[6] = extraEventProps;
    $[7] = getHref;
    $[8] = scope;
    $[9] = trackEvent;
    $[10] = t1;
  } else {
    t1 = $[10];
  }
  return t1;
}